export default "__VITE_ASSET__B3LYZXXn__"